import React, { useEffect } from "react";
import "./plan.css";
import { Modal } from "react-bootstrap";

function Premiumbreakup({ quickQuote, Addon }) {
  useEffect(() => {
    console.log("quickQuote, Addon updated: ", quickQuote, Addon);
  }, [quickQuote, Addon]);
  const selectedObjects = Object?.keys(Addon)?.filter(
    (key) => Addon[key]?.selection === true
  );
  const AddonNetPremium = selectedObjects?.map((key) => Addon[key]?.netPremium);

  const totalAddonPremium = AddonNetPremium?.reduce((acc, currentValue) => {
    let numericalPremium;
    if (typeof currentValue === "string") {
      numericalPremium = parseFloat(currentValue.split(" ")[1]);
    } else if (typeof currentValue === "number") {
      numericalPremium = currentValue;
    } else {
      numericalPremium = 0;
    }
    return acc + numericalPremium;
  }, 0);

  const { otherDiscounts } = quickQuote?.discounts || {};
  //console.log(otherDiscounts)
  const { traiffPremium } = quickQuote?.coverages?.ownDamage || {};
  const { netPremium } = quickQuote?.coverages?.thirdPartyLiability || {};
  const { totalTax } = quickQuote?.serviceTax || {};
  const renderValue = (value, fallback = "N/A") => {
    if (typeof value === "string") {
      return value;
    }
    if (typeof value === "number") {
      return value;
    }
    return fallback;
  };

  const formatCurrency = (value) => {
    if (typeof value === "number") {
      return `₹ ${Math.round(value)}`;
    }
    if (typeof value === "string") {
      const numericValue = parseFloat(value.replace(/[^\d.]/g, ""));
      return isNaN(numericValue) ? "N/A" : `₹ ${Math.round(numericValue)}`;
    }
    return "N/A";
  };
  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          Premium Breakup
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-around">
          <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12">
            <div className="premi-insurer-img">
              <img style={{ width: "75%" }} alt="logo" src={quickQuote?.logo} />
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">IDV</div>
              <div className="w-50 text-end">
                {/* {quickQuote?.vehicle?.vehicleIDV?.idv === 0
                  ? "Not Applicable"
                  : "₹" + quickQuote?.vehicle?.vehicleIDV?.idv} */}
                {quickQuote?.vehicle?.vehicleIDV?.idv === 0
                  ? "Not Applicable"
                  : formatCurrency(quickQuote?.vehicle?.vehicleIDV?.idv)}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">Reg No</div>
              <div className="w-50 text-end">
                {renderValue(quickQuote?.vehicle?.licensePlateNumber)}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">
                {renderValue(quickQuote?.vehicle?.make)}
              </div>
              <div className="w-50 text-end">
                {renderValue(quickQuote?.vehicle?.model)}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">Fuel Type</div>
              <div className="w-50 text-end">Petrol</div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">Reg Year</div>
              <div className="w-50 text-end">
                {renderValue(quickQuote?.vehicle?.registrationDate)}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">Policy Expiry Date</div>
              <div className="w-50 text-end">
                {renderValue(
                  quickQuote?.previousInsurer?.previousPolicyExpiryDate
                )}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
              <div className="w-50">Net Premium</div>
              <div className="w-50 text-end">
                {/* {typeof quickQuote?.netPremium === "string"
                  ? Math.round(
                      parseFloat(quickQuote?.netPremium.replace(/[^\d.]/g, ""))
                    )
                  : quickQuote?.netPremium} */}
                {formatCurrency(quickQuote?.netPremium)}
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12">
            <div className="col-12 bg-info p-2 my-2 text-white">
              <span className="premium_name">A</span>
              Basic OD Premium(+)
            </div>
            <div className="col-12 my-2">
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Basic OD Premium</div>
                <div className="w-50 text-end">
                  {" "}
                  {/* {typeof traiffPremium === "string"
                    ? Math.round(
                        parseFloat(traiffPremium.replace(/[^\d.]/g, ""))
                      )
                    : traiffPremium} */}
                  {formatCurrency(traiffPremium)}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">(A)Total OD Premium</div>
                <div className="w-50 text-end"> </div>
              </div>
            </div>
            <div className="col-12 bg-info p-2 my-2 text-white">
              <span className="premium_name">B</span>
              Discount(-)
            </div>
            <div className="col-12 my-2">
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">NCB</div>
                <div className="w-50 text-end">
                  {quickQuote?.currentNoClaimBonus
                    ? quickQuote?.currentNoClaimBonus === 20
                      ? "20%"
                      : quickQuote?.currentNoClaimBonus === 25
                      ? "25%"
                      : quickQuote?.currentNoClaimBonus === 35
                      ? "35%"
                      : quickQuote?.currentNoClaimBonus === 45
                      ? "45%"
                      : quickQuote?.currentNoClaimBonus === 50
                      ? "50%"
                      : ""
                    : "N/A"}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">(B)Total Discount</div>
                <div className="w-50 text-end">
                  {formatCurrency(otherDiscounts?.[0]?.discountAmount)}
                  {/* {otherDiscounts?.[0]?.discountAmount &&
                  typeof otherDiscounts[0]?.discountAmount === "string"
                    ? Math.round(
                        parseFloat(
                          otherDiscounts[0]?.discountAmount.replace(
                            /[^\d.]/g,
                            ""
                          )
                        )
                      )
                    : otherDiscounts?.[0]?.discountAmoun} */}
                </div>
              </div>
            </div>
            <div className="col-12 bg-info p-2 my-2 text-white">
              <span className="premium_name">C</span>
              TP Premium Calculation(+)
            </div>
            <div className="col-12 my-2">
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Basic Third Party Liablity</div>
                <div className="w-50 text-end">
                  {" "}
                  {/* {typeof netPremium === "string"
                    ? Math.round(parseFloat(netPremium.replace(/[^\d.]/g, "")))
                    : netPremium} */}
                  {formatCurrency(netPremium)}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">(C)Total TP Premium</div>
                <div className="w-50 text-end"> </div>
              </div>
            </div>
            <div className="col-12 bg-info p-2 my-2 text-white">
              <span className="premium_name">D</span>
              Addon Premium(+)
            </div>
            <div className="col-12 my-2">
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Total Addon Premium</div>
                <div className="w-50 text-end">
                  ₹ {Math.round(totalAddonPremium)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-center w-100">
              <div className="p-2 bg-secondary bg-gradient text-white me-1">
                Net Premium (A-B) + C + D = ₹{" "}
                {/* {typeof quickQuote?.netPremium === "string"
                  ? Math.round(
                      parseFloat(quickQuote?.netPremium.replace(/[^\d.]/g, ""))
                    )
                  : quickQuote?.netPremium} */}
                {formatCurrency(quickQuote?.netPremium)}
              </div>{" "}
              +
              <div className="p-2 bg-secondary bg-gradient text-white mx-1">
                Tax
                {/* {typeof totalTax === "string"
                  ? Math.round(parseFloat(totalTax.replace(/[^\d.]/g, "")))
                  : totalTax} */}
                {formatCurrency(totalTax)}
              </div>{" "}
              =
              <div className="p-2 bg-dark bg-gradient text-white ms-1">
                Final Premium Payable <br></br>
                {/* {typeof quickQuote?.grossPremium === "string"
                  ? Math.round(
                      parseFloat(
                        quickQuote?.grossPremium.replace(/[^\d.]/g, "")
                      )
                    )
                  : quickQuote?.grossPremium} */}
                {formatCurrency(quickQuote?.grossPremium)}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </>
  );
}

export default Premiumbreakup;
